import { phoneFormat } from '../shared/util';
import React from 'react';

const getTextWithLineBreak = (sentences) => (
    <>
        {sentences.map((s) => {
            return (
                <>
                    {s}
                    <br className='show-lg-up' />
                </>
            );
        })}
    </>
);

export const appleServiceNumbers = {
    customerService: {
        US: '(866) 258-7419',
        UK: '020 8253 7435',
        DE: '07131 186 222',
        AUS: '03 9522 4099',
        ES: '9009-30413',
        FR: '0800-902128',
        IT: '800-780755',
        CL: '123-0-020-0245',
        AT: '0800 298853',
        FI: '0800 390642',
        IE: '1800 900690',
        NL: '0800 0221662',
        NO: '800 14983',
        SE: '020 79 0261',
        DK: '80-254570',
        CH: '0800 563528',
        NZ: '0800 453988',
        JP: '012-093-8240',
        IN: '0008000404948',
        MX: '800-2002035'
    },
    incorrectDevice: {
        US: '(800) 275-2273',
        UK: '0800-107-6285',
        DE: '0800-6645-451',
        AUS: '1300-321-456',
        ES: '9008-12703',
        FR: '0805 540 003',
        IT: '800-915904',
        CL: '800-380-230',
        AT: '0800 220325',
        FI: '0800 96372',
        IE: '1800 804 062',
        NL: '0800 0201581',
        NO: '240 55133',
        SE: '020 100 529',
        DK: '80-249625',
        CH: '0800 00 1853',
        NZ: '0800 1 27753',
        JP: '0120-277-535',
        MX: '001-866-676-5682',
        IN: '0008001009009'
    },
    standaloneCustomerService: {
        US: '(866) 243-6434'
    }
};

const voiceValues = {
    conversational: {
        scheduling: {
            type4: getTextWithLineBreak([
                "Well, we're still looking for a servicer in your area.",
                "Let's take this offline and we'll call you within 24 hours to schedule service."
            ]),
            recommendServicer: 'Do you have the inside scoop? Is there a servicer you recommend?'
        },
        confirmations: {
            type1: 'It’s a date, we’ll see you then.',
            type2_3: 'Stand by, a technician will contact you soon.',
            type2_EV: 'Stand by, a technician will contact you soon.',
            type4: 'Stand by, our team is looking for a servicer.',
            savedClaim: 'Your claim has been saved.'
        },
        verifyInfo: {
            service: 'Are we coming to the right place and using the best contact info?',
            replacement: 'Are we shipping to the right place and using the best contact info?'
        }
    },
    standard: {
        scheduling: {
            type4: getTextWithLineBreak([
                "We're still looking for a servicer in your area.",
                'We’ll call you within 24 hours to schedule service.'
            ]),
            recommendServicer: 'Is there a servicer you recommend?'
        },
        confirmations: {
            type1: 'Your appointment is confirmed.',
            type2_3: "We'll call you soon to make your appointment.",
            type4: 'We’re locating a servicer and will be in touch soon.',
            savedClaim: 'Your claim has been saved.'
        },
        verifyInfo: {
            service: 'Please confirm your address and preferred contact information.',
            replacement: 'Please confirm your address and preferred contact information.'
        }
    }
};

export const CancelModalParagraph = ({ brandId }) => {
    const lowerBrandId = brandId?.toLowerCase();
    const variableText = textValues[lowerBrandId];

    return (
        <>
            {variableText?.sections?.cancelModalParagraph === 'default' && (
                <p>
                    Home breakdowns are a part of life, canceling your plan will leave you vulnerable to expensive
                    repair bills. You will also lose access to our nationwide network of reliable service technicians.
                </p>
            )}
        </>
    );
};

const textValues = {
    aig: {
        customerService: {
            email: 'AIGServiceCenter@aig.com',
            phone: phoneFormat('XXXXXXXXXX')
        },
        sales: {
            phone: phoneFormat('XXXXXXXXXX')
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Home Warranty Plan',
        planName: 'Protection Plan',
        pageTitle: 'AIG AppleCare Theft and Loss Claims',
        responseTime: '60 days',
        menuItems: {
            viewPlanDetails: true,
            coverageDetails: true,
            reprintContract: true,
            termsAndConditions: true,
            cancelContract: true
        },
        headerLinks: {
            faqs: true,
            coverageDocs: true,
            contactUs: true
        },
        assetLinks: {
            assetCoverages: true,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    apple: {
        customerService: {
            email: 'AIGServiceCenter@aig.com',
            phone: phoneFormat('XXXXXXXXXX')
        },
        sales: {
            phone: phoneFormat('XXXXXXXXXX')
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        pageTitle: 'AIG AppleCare Theft and Loss Claims',
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    arw: {
        customerService: {
            email: 'AIGServiceCenter@aig.com',
            phone: phoneFormat('877-752-6790')
        },
        sales: {
            phone: phoneFormat('XXXXXXXXXX')
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    hwa: {
        customerService: {
            email: '',
            phone: phoneFormat('888-492-7359')
        },
        sales: {
            phone: phoneFormat('866-294-7941')
        },
        portfolioClaim: {
            phone: phoneFormat('844-762-7411')
        },
        claimOverviewHero: {
            planNumber: 'Policy ID',
            planStatus: 'Policy Status',
            totalPlans: 'Total Plans'
        },
        planDetails: {
            paymentType: 'Trade Call Fee'
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    cutler: {
        customerService: {
            email: 'HomeServicesHelp@aig.com',
            phone: phoneFormat('833-607-8225')
        },
        sales: {
            phone: phoneFormat('833-607-8225')
        },
        portfolioClaim: {
            phone: phoneFormat('833-607-8225')
        },
        claimOverviewHero: {
            planNumber: 'Account Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Cutler Home Service Plans',
        planName: 'Service Plan',
        pageTitle: 'Cutler Home Service Plans Claims Portal',
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    njr: {
        customerService: {
            email: 'AIGServiceCenter@aig.com',
            phone: phoneFormat('8884050602')
        },
        sales: {
            phone: phoneFormat('8775314782')
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        planDetails: {
            paymentType: 'Service Fee'
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    et: {
        customerService: {
            email: 'energytexasinfo@aig.com',
            phone: phoneFormat('8776998790')
        },
        sales: {
            phone: phoneFormat('8336917225')
        },
        claimOverviewHero: {
            planNumber: 'Account Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        confirmations: {
            savedClaim: 'Your claim has been saved.'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Partner Protection',
        planName: 'Service Plan',
        pageTitle: 'Partner Protection Claims Portal',
        responseTime: '60 days',
        menuItems: {
            viewPlanDetails: true,
            coverageDetails: true,
            reprintContract: true,
            termsAndConditions: true,
            cancelContract: false
        },
        assetLinks: {
            assetCoverages: false,
            planCoverages: true
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    bestbuy: {
        customerService: {
            email: 'warranty-aigclaimscenter@aig.com',
            phone: phoneFormat('8002503819')
        },
        sales: {
            phone: phoneFormat('8002503819')
        },
        claimOverviewHero: {
            planNumber: 'Plan Number',
            planStatus: 'Plan Status',
            totalPlans: ''
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'AIG Protection Plans',
        planName: 'Protection Plan',
        pageTitle: 'AIG Protection Plans Claims Portal',
        responseTime: '60 days',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: true,
            reprintContract: true,
            termsAndConditions: true,
            cancelContract: false
        },
        assetLinks: {
            assetCoverages: false,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    constellation: {
        customerService: {
            email: 'HomeServicesHelp@aig.com',
            phone: phoneFormat('8332371002')
        },
        sales: {
            phone: phoneFormat('8882434663')
        },
        claimOverviewHero: {
            planNumber: 'Protection Plans',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        confirmations: {
            savedClaim: 'Your claim has been saved.'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Constellation Protection Plans',
        planName: 'Protection Plan',
        pageTitle: 'Constellation Protection Plans Claims Portal',
        responseTime: '60 days',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: true,
            reprintContract: true,
            termsAndConditions: true,
            cancelContract: false
        },
        assetLinks: {
            assetCoverages: true,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    sibi: {
        customerService: {
            email: 'HomeServicesHelp@aig.com',
            phone: phoneFormat('8665287034')
        },
        sales: {
            phone: phoneFormat('8665287034')
        },
        claimOverviewHero: {
            planNumber: 'Account Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        confirmations: {
            savedClaim: 'Your claim has been saved.'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Warranty Service Plans',
        planName: 'Protection Plan',
        pageTitle: 'Warranty Service Plans Claims Portal',
        splashPageBody: 'For information about your plan or to file a claim:',
        responseTime: '60 days',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: false,
            reprintContract: true,
            termsAndConditions: false,
            cancelContract: true
        },
        headerLinks: {
            faqs: false,
            coverageDocs: true,
            contactUs: false
        },
        assetLinks: {
            assetCoverages: false,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    homekick: {
        customerService: {
            email: 'HomeWarrantyCS@aig.com',
            phone: phoneFormat('8772023499')
        },
        sales: {
            phone: phoneFormat('8669445425')
        },
        claimOverviewHero: {
            planNumber: 'Account Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        confirmations: {
            savedClaim: 'Your claim has been saved.'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Eversafe Warranty',
        planName: 'Protection Plan',
        pageTitle: 'Eversafe Warranty Claims Portal',
        responseTime: '30 days',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: true,
            reprintContract: true,
            termsAndConditions: false,
            cancelContract: false
        },
        assetLinks: {
            assetCoverages: true,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    rate: {
        customerService: {
            email: 'RateHomeWarrantyCS@aig.com',
            phone: phoneFormat('8337784727')
        },
        sales: {
            phone: phoneFormat('2062606187')
        },
        claimOverviewHero: {
            planNumber: 'Warranty Plan Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        confirmations: {
            savedClaim: 'Your claim has been saved.'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Rate Whole Home Warranty',
        planName: 'Home Warranty Plan',
        pageTitle: 'Rate Whole Home Warranty Claims Portal',
        splashPageBody: 'For information about your plan or to file a claim:',
        responseTime: '30 days',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: true,
            reprintContract: true,
            termsAndConditions: false,
            cancelContract: false
        },
        assetLinks: {
            assetCoverages: true,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    applestandalone: {
        customerService: {
            email: 'warranty-aigservicecenter@aig.com',
            phone: phoneFormat('8662436434')
        },
        sales: {
            phone: phoneFormat('8662436434')
        },
        claimOverviewHero: {
            planNumber: 'Protection Plan',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'AIG Standalone Theft and Loss Protection',
        planName: 'Home Service Plan',
        pageTitle: 'AIG AppleCare+ with Theft and Loss Claims',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: true,
            reprintContract: true,
            termsAndConditions: false,
            cancelContract: true
        },
        headerLinks: {
            faqs: false,
            coverageDocs: true,
            contactUs: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'standalone'
        },
        sections: {
            reprintMail: false,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: false,
            activePlanTab: true,
            isAccountDetailsEdit: true,
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    flex: {
        customerService: {
            email: 'flexprotectsupport@aig.com',
            phone: phoneFormat('8002353545')
        },
        sales: {
            phone: phoneFormat('8002353545')
        },
        claimOverviewHero: {
            planNumber: 'Service Plans',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        confirmations: {
            savedClaim: 'Your claim has been saved.'
        },
        planDetails: {
            paymentType: 'Service Fee'
        },
        programName: 'Flex Protect',
        planName: '',
        pageTitle: 'Flex Protect Claims',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: false,
            reprintContract: true,
            termsAndConditions: true,
            cancelContract: false
        },
        assetLinks: {
            assetCoverages: false,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: false,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            myPlanTab: true,
            showAccountDetailsButton: true
        }
    },
    sure: {
        customerService: {
            email: 'Warranty-SureHomeWarrantyCS@aig.com ',
            phone: phoneFormat('8444164499')
        },
        sales: {
            phone: phoneFormat('8443355441')
        },
        claimOverviewHero: {
            planNumber: 'Warranty Plan Number',
            planStatus: 'Plan Status',
            totalPlans: 'Total Plans'
        },
        confirmations: {
            savedClaim: 'Your claim has been saved.'
        },
        planDetails: {
            paymentType: 'Trade Service Fee'
        },
        programName: 'Sure Home Warranty',
        planName: 'Home Warranty Plan',
        pageTitle: 'Sure Home Warranty Claims',
        splashPageBody: 'For information about your plan or to file a claim:',
        responseTime: '30 days',
        menuItems: {
            viewPlanDetails: false,
            coverageDetails: false,
            reprintContract: false,
            termsAndConditions: false,
            cancelContract: false
        },
        assetLinks: {
            assetCoverages: true,
            planCoverages: false
        },
        affirmations: {
            showTermsLink: true,
            variant: 'default'
        },
        sections: {
            reprintMail: true,
            reprintEmail: true,
            reprintDownload: true,
            showAllTabs: true,
            isAccountDetailsEdit: false,
            cancelModalParagraph: 'default',
            myPlanTab: false,
            showAccountDetailsButton: false
        }
    }
};

export const CancellationsModalAffirmation = ({ brandId }) => {
    const lowerBrandId = brandId?.toLowerCase();
    const variableText = textValues[lowerBrandId];

    return (
        <>
            <span>I affirm that I have read the</span>
            {variableText?.affirmations?.showTermsLink && (
                <a
                    href='/coveragedocs'
                    className='ml-1 mr-1'
                >
                    Terms and Conditions
                </a>
            )}
            {variableText?.affirmations?.variant === 'default' && (
                <span>
                    and understand canceling after the first 30 days could result in a pro rata refund of the agreement
                    price paid for the remaining term, minus any service costs incurred by {variableText?.programName}.
                    If coverage is canceled after service has been performed, and the agreement price has not yet been
                    paid, I understand I will be responsible for the purchase price of the agreement, or reimbursement
                    of services incurred, whichever is less.
                </span>
            )}
            {variableText?.affirmations?.variant === 'standalone' && (
                <span>
                    and understand canceling after the first 30 days may result in a pro rata refund of the agreement
                    price paid for the remaining term. If coverage is canceled after a replacement has been issued, I
                    understand I will be responsible for the purchase price of the agreement, or reimbursement of
                    services incurred, whichever is less.
                </span>
            )}
        </>
    );
};

const getClientContent = (brandId) => {
    // NPB 03312021 - as of today, HWA is the only brand using alternative voicing/tone. anything other than HWA will return "conversational" text.
    const usingStandardTone = ['hwa'];
    const lowerBrandId = brandId?.toLowerCase();
    const variableVoice = voiceValues[usingStandardTone.includes(lowerBrandId) ? 'standard' : 'conversational'];
    const variableText = textValues[lowerBrandId];
    return { variableText, variableVoice };
};

export default getClientContent;
